import type { ComponentChildren } from "preact";
import { ExploreButtons } from "../explore/ExploreButtons";
import { Toggle } from "../settings/Toggle";

export const Spinner = () => (
  <div class="flex justify-center items-center py-8">
    <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600" />
  </div>
);

export const UnreadFilter = ({ unreadOnly, onChange }: { unreadOnly: boolean; onChange: (value: boolean) => void }) => (
  <div class="mb-4 flex items-center gap-2 text-sm text-neutral-500">
    <Toggle checked={unreadOnly} onChange={onChange} />
    <span class="text-sm text-neutral-500">{unreadOnly ? "Unread" : "All"}</span>
  </div>
);

export const EmptyList = ({ message }: { message?: ComponentChildren }) => {
  if (!message) {
    return <div class="text-center py-5 text-neutral-500">No articles found</div>;
  }
  return (
    <div class="min-h-screen flex justify-center text-gray-900 dark:text-gray-100">
      <div class="max-w-md mx-auto px-6 py-12 text-center">
        <div class="bg-white dark:bg-neutral-800 border border-neutral-200 dark:border-neutral-700 rounded-lg p-8 mb-6 shadow-md">
          <p class="text-gray-600 dark:text-gray-400 mb-4">{message}</p>
        </div>
        <div class="mt-8">
          <ExploreButtons />
        </div>
      </div>
    </div>
  );
};

export type ListFooterProps = {
  total: number;
  shown: number;
  hasMore: boolean;
  endMessage?: ComponentChildren;
  onLoadMore: () => void;
};

export const ListFooter = ({ total, shown, hasMore, endMessage, onLoadMore }: ListFooterProps) => (
  <div class="text-center py-5">
    {!hasMore && total > 0 && <div class="text-gray-500 text-center my-5">{endMessage ?? "No more articles"}</div>}
    {hasMore && (
      <button type="button" onClick={onLoadMore} class="w-full px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
        Load More
      </button>
    )}
    {shown < total && (
      <div class="text-center text-xs mt-1 pb-5 text-neutral-500">
        Showing {shown} of {total} articles
      </div>
    )}
  </div>
);
